import React from 'react'


interface PlusIconProps {
  fillColor?: string
}

function PlusIcon({ fillColor = "#323232" }: PlusIconProps) {
  return (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 8H15" stroke={fillColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 1V15" stroke={fillColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default PlusIcon